import React, {PropTypes} from 'react';
import classNames from 'classnames';
import {formatCurrency} from 'shared/util/formatCurrency';
Number.prototype.formatCurrency = formatCurrency;

const VirtualEvent = ({
  balanceDue,
  selectable,
  selected,
  tournamentId,
  virtualEventId,
  virtualEventName,
  onSelectChecked,
  onVirtualEventLinkClick
}) => (
  <div className="list-group-item-labeled">
    <div className="list-group-item-labeled-child custom-checkbox-container"
       style={{width: 25}}>
      <input
        type="checkbox"
        id={`entry-${virtualEventId}`}
        disabled={!selectable}
        checked={selected}
        onChange={() => onSelectChecked(tournamentId, virtualEventId)}
      />
      <label
        htmlFor={`entry-${virtualEventId}`} />
    </div>
    <div className="list-group-item-labeled-child has-link"
      style={{width: 860}}
      onClick={() => onVirtualEventLinkClick(virtualEventId)}>
      <span>{'Virtual Event'}</span>
      <span>{virtualEventName}</span>
    </div>
    <div className={classNames(
        'list-group-item-labeled-child',
        {'bg-danger': balanceDue}
      )}
      style={{width: 145, height: 40, alignItems: 'center', justifyContent: 'center'}}>
      {
        balanceDue
        ? <strong className="flex center" >{`$${balanceDue.formatCurrency(2)} DUE`}</strong>
        : null
      }
    </div>
  </div>
);

VirtualEvent.propTypes = {
  balanceDue: PropTypes.number,
  selectable: PropTypes.bool,
  selected: PropTypes.bool,
  tournamentId: PropTypes.string,
  virtualEventId: PropTypes.string,
  virtualEventName: PropTypes.string,
  onSelectChecked: PropTypes.func,
  onVirtualEventLinkClick: PropTypes.func
};

VirtualEvent.defaultProps = {
  balanceDue: 0
};

export default VirtualEvent;



// WEBPACK FOOTER //
// ./src/features/admin/captainDetail/VirtualEvent.jsx